// extracted by mini-css-extract-plugin
export default {"container":"jo-z","ratingLayout":"ko-z","ratingLabel":"lo-z","nonInteractiveRatingLabel":"mo-z"};